<template>
  <button 
    v-if="visible" 
    @click="handleClick" 
    :disabled="disable"
    class="custom-button">
    <span v-if="icon" class="button-icon material-symbols-outlined">{{ icon }}</span>
    <span class="button-label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    action: {
      type: Function,
      required: true
    },
    disable: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClick() {
      if (!this.disable || !this.visible) {
        this.action(this.itemId);
      }
    }
  }
};
</script>

<style scoped>
.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.3s ease;
}

.custom-button:disabled {
  cursor: not-allowed;
}

.custom-button:hover {
  background-color: #f4f4f4;
}

.button-icon {
  margin-right: 8px;
  font-size: 16px;
  color: #666;
}

.button-label {
  flex-grow: 1;
}
</style>
